import { z } from 'zod';
import { timestampSchema } from './common';

export const MAIL_TEXT_KEYS = [
  'welcome',
  'renewal-receipt',
  'payment-failed',
  'trial-ending',
  'cancellation',
  'access-ended',
] as const;

export const mailTextKeySchema = z.enum(MAIL_TEXT_KEYS);

export const mailTextSchema = z.object({
  subject: z.string().trim().min(1).max(150),
  heading: z.string().trim().min(1).max(120),
  body: z.string().trim().min(1).max(3000),
  actionLabel: z.string().trim().min(1).max(40).nullable(),
  note: z.string().trim().min(1).max(500).nullable(),
});

export const mailTextViewSchema = z.object({
  key: mailTextKeySchema,
  label: z.string(),
  description: z.string(),
  variables: z.array(z.object({ name: z.string(), description: z.string(), example: z.string() })),
  extras: z.array(z.string()),
  hasAction: z.boolean(),
  custom: z.boolean(),
  text: mailTextSchema,
  defaults: mailTextSchema,
  updatedBy: z.string().nullable(),
  updatedAt: timestampSchema.nullable(),
});

export const mailTextListSchema = z.object({ mails: z.array(mailTextViewSchema) });

export const mailTextParamsSchema = z.object({ key: mailTextKeySchema });

export const mailPreviewSchema = z.object({ subject: z.string(), html: z.string() });

export type MailTextKey = (typeof MAIL_TEXT_KEYS)[number];
export type MailTextInput = z.infer<typeof mailTextSchema>;
export type MailTextView = z.infer<typeof mailTextViewSchema>;
export type MailTextList = z.infer<typeof mailTextListSchema>;
export type MailPreview = z.infer<typeof mailPreviewSchema>;
